import axios from "../config/axios-chatbot";

const base = (flowUid) => `/api/flow-project/${flowUid}/ami`;

export const AmiRepository = {
  // Health
  getHealth: (flowUid) => {
    return axios.get(`${base(flowUid)}/health`);
  },

  // Channels
  listChannels: (flowUid) => {
    return axios.get(`${base(flowUid)}/channels`);
  },
  getChannelVar: (flowUid, channel, variable) => {
    return axios.get(`${base(flowUid)}/channels/vars`, {params: {channel, variable}});
  },
  setChannelVar: (flowUid, channel, data) => {
    return axios.post(`${base(flowUid)}/channels/vars`, data, {params: {channel}});
  },
  hangupChannel: (flowUid, channel, data = {}) => {
    return axios.post(`${base(flowUid)}/channels/hangup`, data, {params: {channel}});
  },
  redirectChannel: (flowUid, channel, data) => {
    return axios.post(`${base(flowUid)}/channels/redirect`, data, {params: {channel}});
  },

  // Extensions
  listExtensions: (flowUid) => {
    return axios.get(`${base(flowUid)}/extensions`);
  },
  registerExtension: (flowUid, data) => {
    return axios.post(`${base(flowUid)}/extensions`, data);
  },
  getExtension: (flowUid, exten) => {
    return axios.get(`${base(flowUid)}/extensions/${exten}`);
  },
  enableExtension: (flowUid, exten) => {
    return axios.post(`${base(flowUid)}/extensions/${exten}/enable`);
  },
  disableExtension: (flowUid, exten, data = {}) => {
    return axios.post(`${base(flowUid)}/extensions/${exten}/disable`, data);
  },
  redirectExtension: (flowUid, exten, data) => {
    return axios.post(`${base(flowUid)}/extensions/${exten}/redirect`, data);
  },
  resyncExtensions: (flowUid) => {
    return axios.post(`${base(flowUid)}/extensions/resync`);
  },
  regenerateConf: (flowUid) => {
    return axios.post(`${base(flowUid)}/extensions/regenerate-conf`);
  },
  reloadDialplan: (flowUid) => {
    return axios.post(`${base(flowUid)}/dialplan/reload`);
  },

  // Extension blocks / slots
  listExtensionBlocks: (flowUid) => {
    return axios.get(`${base(flowUid)}/extensions/blocks`);
  },
  reserveExtensionBlock: (flowUid, data) => {
    return axios.post(`${base(flowUid)}/extensions/blocks`, data);
  },
  getAvailableSlots: (flowUid, flow_uid) => {
    return axios.get(`${base(flowUid)}/extensions/slots/available`, {params: flow_uid ? {flow_uid} : {}});
  },

  // Calls
  originateCall: (flowUid, data) => {
    return axios.post(`${base(flowUid)}/calls/originate`, data);
  },
};
